import * as React from "react";

interface SvgLineArrowProps {
  width?: number;
  direction: "Up" | "Down";
}

const SvgLineArrow = ({ width = 18, direction }: SvgLineArrowProps) => (
  <svg
    width={width}
    height={(width / 18) * 20}
    viewBox="0 0 313 162"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {direction === "Up" ? (
      <path d="M4 4L154.5 154.5L309.5 4" stroke="#100F0F" strokeWidth="30" />
    ) : (
      <path
        d="M4 154.5L154.5 4L309.5 154.5"
        stroke="#100F0F"
        strokeWidth="30"
      />
    )}
  </svg>
);
export default SvgLineArrow;
